import e from "./hooks/useAsync.js";
import o from "./hooks/useBeforeUnload.js";
import r from "./hooks/useDebounceWithOnBlur.js";
import t from "./hooks/useHash.js";
import s from "./hooks/useKeyboardEnter.js";
import m from "./hooks/useKeyboardTab.js";
import u from "./hooks/useMouseLeftClick.js";
import i from "./hooks/useScreenReader.js";
const f = {
  useDebounceWithOnBlur: r,
  useHash: t,
  useAsync: e,
  useBeforeUnload: o,
  useKeyboardTab: m,
  useMouseLeftClick: u,
  useKeyboardEnter: s,
  useScreenReader: i
}, h = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: f
}, Symbol.toStringTag, { value: "Module" }));
export {
  f as h,
  h as i
};
